import {
  buildTruecallerLink,
  resolveSelectedContactPhone,
  resolveCustomerContact,
} from "@/modules/common/utils/customer-contact";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { queryClient } from "@/queryClient";
import { useContext } from "react";
import { useMutation } from "@tanstack/react-query";
import { startCallV2 } from "../../api/lead-page.v2.api";

const useLeadContactMethods = () => {
  const { lead } = useContext(LeadPageContext);

  const handleSearchTruecaller = (phoneNumber?: string) => {
    if (lead?.data?.lead?.do_not_call) return;
    const numberToSearch = resolveSelectedContactPhone(
      phoneNumber,
      lead?.data?.lead?.lead_telephones,
    );
    const url = buildTruecallerLink(numberToSearch);

    if (url) window.open(url, "_blank", "noopener,noreferrer");
  };

  const { mutate: startCallMutation, isLoading } = useMutation({
    mutationFn: ({
      journeyUid,
      zoomCall,
    }: {
      journeyUid: number | string;
      zoomCall?: boolean;
    }) => startCallV2(journeyUid, zoomCall),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getComments"] });
      queryClient.invalidateQueries({ queryKey: ["lead-activity"] });
    },
  });

  const handleStartCall = async (zoomCall?: boolean): Promise<void> => {
    const journeyUid = lead?.data?.lead?.journey_uid;
    if (
      !journeyUid ||
      lead?.data?.lead?.do_not_call ||
      (!zoomCall &&
        !resolveCustomerContact(lead?.data?.lead?.lead_telephones).phone)
    )
      return;

    await new Promise<void>((resolve) => {
      startCallMutation(
        { journeyUid, zoomCall },
        {
          onSettled: resolve,
        },
      );
    });
  };

  return {
    handleSearchTruecaller,
    handleStartCall,
    isLoading,
  };
};

export default useLeadContactMethods;
